import { useMediaQuery, useTheme } from '@mui/material';
import { between } from '@ui/style/style';
import { headerHeight, spaceAboveHeader, spaceBelowHeader } from '@ui/style/variables';
const headingHeight = 48;
const spaceBelowHeading = 0.5;
const pageEndPadding = 20;
const stepCount = 24;
const StepName = 40;
const scrollableContentTopPadding = 8;
export const contentContainerHeight = `${spaceAboveHeader + headerHeight + spaceBelowHeader + headingHeight + spaceBelowHeading + pageEndPadding}px`;
export const scrollableContentHeight = `${stepCount + StepName + scrollableContentTopPadding}px`;
const useCreateEventStyles = (mode = '', tab = '') => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('xl'));
    return {
        main: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
            // px: { xs: 0, lg: clamp.calculate(8, 32) }
        },
        mobileScreenHeader: {
            ...between,
            backgroundColor: theme.palette.background.paper,
            // px: clamp.calculate(8, 32),
            // py: 1,
            height: '100%',
            borderRadius: 2
        },
        mobileScreenHeadingButton: {
            ...between
        },
        bottomDrawer: {
            p: 2,
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            height: '70%',
            overflowY: 'auto'
        },
        contentContainer: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
        },
        formContainer: {
            height: isSmallScreen
                ? mode === 'meta'
                    ? `calc(100dvh - 215px)`
                    : `calc(100dvh - 215px)`
                : `calc(100dvh - ${contentContainerHeight})`,
            // padding: isSmallScreen ? 1 : undefined,
            paddingRight: 1,
            pb: isSmallScreen && tab === 'form' ? (mode === 'meta' ? 3 : 5) : 0
            // overflow: 'auto'
        }
    };
};
export default useCreateEventStyles;
